"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Return the country code prefix for selected language
 *  for en language eg: 966+
 * for ar language eg: +966
 * @param {String} countryCode
 * @param {Boolean} isArabic
 * @returns {String}
 */
function getCountryCodePrefix(countryCode, isArabic) {
  return isArabic ? "".concat(countryCode, "+") : "+".concat(countryCode);
}
var _default = exports["default"] = getCountryCodePrefix;